import { IModuleInitializerParams } from "@/Common/Modularity/ModuleInitializer";
import { ModuleInitializerBuilder } from "@/Common/Modularity/ModuleInitializerBuilder";
import { ModuleNames } from "@/Modules/ModuleNames";

/**
 * Determines if the OntarioMd Health Report Manager module should be loaded based on the clinic settings.
 * @param params The module initializer parameters.
 * @returns True if the OntarioMd Health Report Manager module should be loaded, false otherwise.
 */
function shouldLoadOntarioMdHealthReportManagerModule(params: IModuleInitializerParams): boolean {
    return params.clinicSettings.EnableOntarioMdHealthReportManager;
}

const initializeOntarioMdHealthReportManager = new ModuleInitializerBuilder()
    .withConditionalLoading(shouldLoadOntarioMdHealthReportManagerModule)
    .build(ModuleNames.OntarioMdHealthReportManager, async () => (await import("./OntarioMdHealthReportManagerModule")).default);

export default initializeOntarioMdHealthReportManager;
